"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useText72Init = void 0;
const react_1 = require("react");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const useText72Init = (response) => {
    const [words, setWords] = (0, react_1.useState)([[], [], []]);
    const [referenceWords, setReferenceWords] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (response) {
            setReferenceWords(response.form || []);
            if (((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) === 'voice_picture') {
                const maxGroupCount = response.form.reduce((max, item) => { var _a; return Math.max(max, (_a = item.group) !== null && _a !== void 0 ? _a : 0); }, 0);
                setWords(Array.from({ length: maxGroupCount }, () => []));
            }
            else {
                setWords([[], [], []]);
            }
            window.infoRep = [{ rep_id: 1, category_name: '', system_time: '', startTime: Date.now() }];
            window.checkedAnswer = uiConfigs_1.initialButtonState;
        }
    }, [response]);
    return { words, setWords, referenceWords, setReferenceWords };
};
exports.useText72Init = useText72Init;
